<template>
    <div class="c-row">
        <div class="c-tr">
            <div class="c-tw w-left">
                <div class="c-td is-1">
                    <div class="typo-label">ID promocji</div>
                    {{ data.id }}
                </div>
                <div class="c-td is-2">
                    <h3 class="c-promos-title h5">{{ data.name }}</h3>

                    <p class="c-promos-desc">{{ data.type }}</p>
                    <span class="c-promos-date"
                        datetime
                    >od
                        {{ $moment(data.startDate).format('DD-MM-YYYY') }} do
                        {{ $moment(data.endDate).format('DD-MM-YYYY') }}</span>

                    <div class="c-promos-logo">
                        <div class="c-fig c-fig--logo">
                            <!-- <img src="static/logo-grupa-zywiec.png" class="c-fig__img" alt /> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="c-tw w-right">
                <div class="c-td is-3">
                    <div class="typo-label">Status</div>
                    <span v-if="data.status === 1" class="status is-success">
                        <span>Aktywna</span>
                    </span>
                    <span
                        v-if="data.status === 3"
                        class="status is-canceled"
                        v-tooltip="'Promocja anulowana przez producenta'"
                    >
                        <a-icon icon="Info" />
                        <span>Anulowana</span>
                    </span>
                    <span v-if="data.status === 4" class="status is-finished">
                        <a-icon icon="Info" />
                        <span>Zakończona</span>
                    </span>
                </div>
                <div class="c-td is-4">
                    <div class="typo-label">Liczba użyć</div>
                    {{ data.used }}
                </div>
                <div class="c-td is-5">
                    <div class="typo-label">Prognozowany Zwrot Kosztów</div>
                    {{ (+data.refund).toFixed(2) }} zł
                </div>
                <div class="c-td is-6">
                    <button
                        class="btn btn-auto c-promos-toggle"
                        data-toggle="collapse"
                        data-target="#reports-table-1"
                        aria-controls="reports-table-1"
                        aria-expanded="false"
                        @click="showShops = !showShops"
                    >
                        <a-icon icon="Dropdown" />
                        <span class="d-inline d-lg-none">Lokalizacje</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="c-tm collapse" :class="{ show: showShops }">
            <h4 class="h5">Lokalizacje</h4>

            <table class="t">
                <tbody>
                    <tr v-for="(shop, idxx) in data.shops" :key="idxx">
                        <td class="t-d is-1">
                            {{
                                `${shop.name}, ${shop.street} ${shop.zipCode} ${shop.city}`
                            }}
                        </td>
                        <td class="t-d is-2"></td>
                        <td class="t-d is-3">{{ shop.used }}</td>
                        <td class="t-d is-4">
                            {{
                                !isNaN(+shop.refund)
                                    ? (+shop.refund).toFixed(2) + ' zł'
                                    : '-'
                            }}
                        </td>
                        <td class="t-d is-5"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showShops: false
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    }
}
</script>
